// filter-defaults.js

document.addEventListener('DOMContentLoaded', function() {
  console.log("filter-defaults.js loaded – DOMContentLoaded fired");

  // 1) Find the “In stock” checkbox (name="filter.v.availability", value="1")
  var inStockBox = document.querySelector(
    'input[type="checkbox"][name="filter.v.availability"][value="1"]'
  );
  if (!inStockBox) {
    console.log("No 'In stock' checkbox on this page—nothing to do.");
    return;
  }

  // 2) If it’s not already checked, invoke .click() so the theme's own handler runs:
  if (!inStockBox.checked) {
    console.log("Auto‐triggering click on 'In stock' ✓");
    inStockBox.click(); 
    // .click() will toggle .checked → true, then fire 'click' and 'change' events,
    // exactly as if a user clicked. The theme's built-in listener will do the AJAX or full reload.

    // (No need to manually dispatchEvent('change') or do our own fetch—but if you want a fallback, see below.)
  } else {
    console.log("'In stock' was already checked—skipping auto‐click.");
  }
});


/**
 * Fallback: rebuild the URL & fetch the updated section via AJAX yourself.
 * (You probably won't need this now that you're letting the theme handle it.)
 */
function reloadSectionWithInStock() {
  var basePath = window.location.pathname;
  var params = new URLSearchParams(window.location.search);

  // Force filter.v.availability=1
  params.set('filter.v.availability', '1');

  // Force section_id if you ever need Shopify's section API:
  var sectionId = 'template--25324368298366__product-grid';
  params.set('section_id', sectionId);

  var fetchUrl = basePath + '?' + params.toString();
  console.log("Fetching updated section via AJAX →", fetchUrl);

  fetch(fetchUrl, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(function(response) {
    if (!response.ok) throw new Error("Network response was not OK: " + response.status);
    return response.json();
  })
  .then(function(json) {
    var newHtml = (json.sections || {})[sectionId];
    if (!newHtml) {
      console.warn("No HTML returned for section_id:", sectionId, json);
      return;
    }

    // Inject the new HTML back into the page
    var selector = '[data-section-id="' + sectionId + '"]';
    var oldSection = document.querySelector(selector) || document.getElementById(sectionId);

    if (oldSection) {
      oldSection.innerHTML = newHtml;
      console.log("Replaced HTML for section:", sectionId);
    } else {
      console.warn("Could not find section container in DOM:", selector, sectionId);
    }
  })
  .catch(function(err) {
    console.error("Error fetching updated section:", err);
  });
}
